import { render, staticRenderFns } from "./CASignVerify.vue?vue&type=template&id=bfca6986&scoped=true&"
import script from "./CASignVerify.vue?vue&type=script&lang=ts&"
export * from "./CASignVerify.vue?vue&type=script&lang=ts&"
import style0 from "./CASignVerify.vue?vue&type=style&index=0&id=bfca6986&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfca6986",
  null
  
)

export default component.exports